import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, NgZone, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';
import { first } from 'rxjs/operators';
import { Cliente } from '../../../core/model/cliente';
import { ComboGrupo } from '../../../core/model/combos';
import {
  DetalleExpediente, ElasticExpedientesByKeyword, Expedientes, Imagen, InventoryIdenty, IResultadoDocument, Valores,
  ValoresView, FullTextSummaryHighlight, ValuesWithFullTextHighlight, ResponseAddRelacionContenidoUnidadDocumental
} from '../../../core/model/inventories';
import { Page } from '../../../core/model/page';
import { ResizedEvent } from '../../../core/model/resized-event';
import { Userprofile } from '../../../core/model/users';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { ClientesService } from '../../../core/services/clientes.service';
import { FileDownloaderService } from '../../../core/services/file-downloader.service';
import { HighlightService } from '../../../core/services/highlight.service';
import { ImagenCacheBufferService } from '../../../core/services/imagen-cache-buffer.service';
import { InventariosService } from '../../../core/services/inventarios.service';
import { PdfService } from '../../../core/services/pdf.service';
import { SeriesService } from '../../../core/services/series.service';
import { ShoppingElementsService } from '../../../core/services/shopping-elements.service';
import { UsersService } from '../../../core/services/users.service';
import { UtilitiesService } from '../../../core/services/Utility/utilities.service';
import { ModalShowTextComponent } from '../../../utils/modal-show-text/modal-show-text.component';
import { DatePipe } from '@angular/common';
import { UtcDatePipe } from '../../../core/pipes/utc-date-pipe';
import { ServiceConfigService } from '../../../core/services/service-config.service';
import { Config } from '../../../core/model/service-config';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-expediente-detalle',
  templateUrl: './expediente-detalle.component.html',
  styleUrls: ['./expediente-detalle.component.css'],
  providers: [FileDownloaderService],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(500, style({ opacity: 1 }))
      ])
    ]),
    trigger('slideDown', [
      state('in', style({
        opacity: 1,
        height: '*'
      })),
      state('out', style({
        opacity: 0,
        height: '0'
      })),
      transition('in => out', animate('300ms ease-in-out')),
      transition('out => in', animate('300ms ease-in-out'))
    ])
  ]
})
export class ExpedienteDetalleComponent implements OnInit {

  @ViewChild('pdfContents') private pdfContents: ElementRef;
  @ViewChild('pdfCanvas') private pdfCanvas: ElementRef;
  @ViewChild('textLayer') private textLayer: ElementRef;
  @ViewChild('popupShare') private popupShare: TemplateRef<any>;


  @ViewChild('tableRecords') table: any;
  @ViewChild('pdfViewer') private pdfComponent: PdfViewerComponent;


  modalRef: BsModalRef;

  isIE: boolean;
  isEdge: boolean;

  rootBreadcumb: string;
  childBreadcumb: string;

  cliente: Cliente;
  creationUserName: string;
  serie: any;

  detalleExpedienteData: DetalleExpediente;
  mensajeToShow: string;

  isDocoutUser: boolean;
  isSupervisor = false;
  isAdmin = false;

  userPermissionContainerDetails: boolean;
  userPermissionPartialLoan: boolean;

  showPdfNavigationButtons = false;

  hasData = false;
  requestProcessing = false;

  zoom = '100%';
  zoomPercentage = 1;
  numberPdfPage = 1;
  numberPdfPageText = '1';
  numberPdfHojasTotales: number;

  partialIdSelected: number;

  GUIDSelected: string;

  page = new Page();

  values: ValoresView = new ValoresView();

  pdfSrc: Observable<ArrayBuffer>;
  pdfSrcSyncronous: ArrayBuffer;

  clientGroups: ComboGrupo[];

  loadingRecord = false;
  isInDetails = true;
  isInDocuments = false;
  isInRequestHistory = false;
  isInAccessFileHistoric = false;
  isInRecordLocation = false;
  isInAccessChangesHistoric = false;
  hasFilesShareable = false;

  renderText = false;
  linkShared: string;
  showChanges = false;

  loading = false;

  // ngx-datatable options
  customMessages = {
    emptyMessage: 'No hay usuarios disponibles',
    totalMessage: 'Total',
    selectedMessage: 'Selección'
  };
  customClasses = {
    sortAscending: 'fas fa-sort-up',
    sortDescending: 'fas fa-sort-down',
    pagerLeftArrow: 'fas fa-chevron-left',
    pagerRightArrow: 'fas fa-chevron-right',
    pagerPrevious: 'fas fa-step-backward',
    pagerNext: 'fas fa-step-forward'
  };

  showChangeHistory = false;
  recordGroups: number[];
  loadingRecordGroups = false;

  obsPartial = '';
  isModalEdit: boolean;

  imageSecurityLevelState = 'out';
  private serviceConfig: Config;
  hasPrestamos = false;
  hasInserciones = false;

  constructor(private inventoryService: InventariosService,
    private authService: AuthenticationService,
    private translateService: TranslateService,
    private seriesService: SeriesService,
    private clientesService: ClientesService,
    private usersService: UsersService,
    private fileService: FileDownloaderService,
    private elem: ElementRef,
    private zone: NgZone,
    private highlightService: HighlightService,
    private pdfService: PdfService,
    private utilitiesService: UtilitiesService,
    private modalService: BsModalService,
    private imagenCacheService: ImagenCacheBufferService,
    private toastr: ToastrService,
    private shoppingElementsService: ShoppingElementsService,
    private datePipe: DatePipe,
    private utcPipe: UtcDatePipe,
    private serviceConfigService: ServiceConfigService
  ) {
    this.isIE = utilitiesService.isIE();
    this.isEdge = utilitiesService.isEdge();
    this.userPermissionContainerDetails = true;
  }

  ngOnInit() {
    this.chargeDataPage();
  }

  isCalledFromConsultas(): boolean {
    return this.inventoryService.isCalledFromConsultas();
  }

  private chargeDataPage() {
    this.getInitialData();
    this.hasData = this.detalleExpedienteData != null;

    this.userPermissionPartialLoan = this.authService.permisosPartialLoan;

    if (this.hasData) {
      if (this.detalleExpedienteData.expediente.document.imagenAsociada) {
        this.putDocumentInViewer(this.detalleExpedienteData.expediente.document.imagenAsociada);
      }

      if (this.detalleExpedienteData.expediente.document.valores) {
        this.values = this.proccessValues(
          this.detalleExpedienteData.expediente.document.valores,
          this.detalleExpedienteData.keywords
        );
      }

      if (this.detalleExpedienteData.expediente.document.parciales) {
        this.page.pageNumber = 1;
        this.page.size = 10;
        this.page.totalElements = this.detalleExpedienteData.expediente.document.parciales.length;
        this.page.totalPages = Math.ceil(this.page.totalElements / this.page.size);
      }
    }
  }

  callAddConsultaContenido(record: InventoryIdenty, isParcial: boolean, textParcial: string = null) {
    this.loading = true;
    this.inventoryService.addDocumentoConsulta(record, isParcial, textParcial)
      .subscribe(
        (r: ResponseAddRelacionContenidoUnidadDocumental) => {
          if (!r.isOk) {
            this.toastr.error(this.translateService.instant('consultas.consultaddnook'));
          } else {
            this.toastr.success(this.translateService.instant('consultas.consultaok'));
            // 🐱‍👤 Despues de consultarlo con Esther, no vuelvo a la solicitud una vez encontrado el expediente a consultar físicamente
            // si luego dicen que vuelva a la solicitud, descomentar la siguiente linea
            // this.inventoryService.returnToSolicitud();
          }
        },
        (err) => {
          this.toastr.error(this.translateService.instant('consultas.errorconsulta'));
          if (this.inventoryService.tratarError(err) !== '') {
            this.toastr.error(this.inventoryService.tratarError(err));
          }
          this.loading = false;
        },
        () => this.loading = false
      );
  }

  private hasServiceConfig(configName): boolean {
    return this.serviceConfig.serviceConfigs.some(serviceConfig => serviceConfig.nombreServicio == configName);
  }

  private proccessValues(values: Valores, keywords?: ElasticExpedientesByKeyword): any {
    let valueAux = [];
    this.values.rows = [];
    let contador = 0;


    for (const key of values.keys()) {
      const keyAux = key.startsWith('*') ? key.substring(1) : key;
      if (contador % 2 == 0 && valueAux.length != 0) {
        this.values.rows[this.values.rows.length] = [...valueAux];
        valueAux = [];
      }
      const value = this.getValueWithHighlight(keywords, values[keyAux] || '');
      valueAux.push({
        key: keyAux,
        value: value
      });
      contador++;
    }
    if (valueAux.length) {
      this.values.rows[this.values.rows.length] = [...valueAux];
    }
    return this.values;
  }

  private getValueWithHighlight(keywords: ElasticExpedientesByKeyword, value: any): any {
    const isFieldMultivalue = this.isMultivalue(value);
    if (!isFieldMultivalue) {
      if (!value) {
        return ' ';
      }

      if (!keywords) {
        const textValue = new FullTextSummaryHighlight(value.toString(), false);
        return new ValuesWithFullTextHighlight([textValue], isFieldMultivalue);
      }

      return this.highlightService.setHighlitghtsInText(
        value.toString(),
        this.detalleExpedienteData.keywords.PALABRAS_CLAVE,
        isFieldMultivalue
      );
    }

    if (!keywords) {
      return value;
    }

    const values = [];
    for (const val of value) {
      const valHighlight = this.highlightService.setHighlitghtsInText(
        val.toString(),
        this.detalleExpedienteData.keywords.PALABRAS_CLAVE,
        isFieldMultivalue
      );
      values.push(valHighlight);
    }

    return values;

  }

  private getInitialData() {
    this.serviceConfig = this.serviceConfigService.getServiceConfig();
    this.hasPrestamos = this.hasServiceConfig('PRESTAMO');
    this.hasInserciones = this.hasServiceConfig('INSERCION') && !this.inventoryService.isCalledFromConsultas();
    this.detalleExpedienteData = this.inventoryService.getDetalleExpediente();
    if (this.detalleExpedienteData) {
      const valores = this.detalleExpedienteData.expediente.document.valores;
      valores.keys().filter(key => key.startsWith('*')).forEach(key => valores[key.substring(1)] = valores[key]);

      if (this.detalleExpedienteData.expediente.document.imagenAsociada) {
        this.clientesService.getAreFilesShareable(this.detalleExpedienteData.expediente.document.clienteId).pipe(first())
          .subscribe(result => {
            this.hasFilesShareable = result;
          });
      }

      this.userPermissionContainerDetails = this.authService.getPermissionContainerDetails();

      this.authService.isDocOutUser()
        .then((isDocUser: boolean) => {
          this.isDocoutUser = isDocUser;
        });

      this.authService.getClienteName$().subscribe(rootBreadcumb => {
        this.rootBreadcumb = rootBreadcumb;
      });

      if (this.detalleExpedienteData) {

        this.clientesService.getClientById(this.detalleExpedienteData.expediente.document.clienteId)
          .subscribe((client: Cliente) => {
            this.cliente = client;
          });

        this.seriesService.getSerieById(this.detalleExpedienteData.expediente.document.serieId)
          .subscribe(serie => {
            this.serie = serie;
          });

        this.usersService.getUserNameById(this.detalleExpedienteData.expediente.document.usuarioCreacionId)
          .subscribe((name: string) => {
            this.creationUserName = name;
          });
        this.authService.isSupervisorUserObs().subscribe(supervisor => {
          this.isSupervisor = supervisor;
        });

        this.authService.isAdminUserObs().subscribe(admin => {
          this.isAdmin = admin;
          if (this.isAdmin && this.detalleExpedienteData) {
            this.loadingRecordGroups = true;

            this.clientesService.getGruposCliente(this.detalleExpedienteData.expediente.document.clienteId)
              .subscribe((groups: ComboGrupo[]) => {
                this.clientGroups = groups;
                const gruposAcceso = this.detalleExpedienteData.expediente.document.gruposAcceso;
                if (gruposAcceso && gruposAcceso.length) {
                  this.recordGroups = gruposAcceso.map(grupoAcceso => grupoAcceso.grupoId);
                }

                this.loadingRecordGroups = false;
              });
          }
        });

      }

    }
  }

  lessZoom(decreaseZoom: number) {
    const zoom = parseInt(this.zoom.split('%')[0], 10);

    this.zone.run(() => {
      const zoomNumber: number = (zoom - decreaseZoom) <= 0 ? 0 : (zoom - decreaseZoom);

      this.zoom = zoomNumber + '%';

      this.zoomPercentage = zoomNumber / 100;
    });

    this.setMarkHighligth();

  }

  moreZoom(increaseZoom: number) {
    const zoom = parseInt(this.zoom.split('%')[0], 10);

    this.zone.run(() => {
      const zoomNumber: number = (zoom + increaseZoom);

      this.zoom = zoomNumber + '%';

      this.zoomPercentage = zoomNumber / 100;
    });

    this.setMarkHighligth();
  }

  setShowPdfNavigationButtons(show: boolean) {
    this.showPdfNavigationButtons = show;
    event.preventDefault();
    return false;
  }

  goFirstPage() {
    if (this.numberPdfPage != 1) {
      this.zone.run(() => {
        this.numberPdfPage = 1;
        this.numberPdfPageText = this.numberPdfPage.toString();
      });

      this.setMarkHighligth();
    }

  }

  goLastPage() {
    if (this.numberPdfPage != this.numberPdfHojasTotales) {
      this.zone.run(() => {
        this.numberPdfPage = this.numberPdfHojasTotales;
        this.numberPdfPageText = this.numberPdfPage.toString();
      });

      this.setMarkHighligth();
    }
  }

  goBeforePage() {
    if (this.numberPdfPage != 1 && this.numberPdfPage > 0) {
      this.zone.run(() => {
        this.numberPdfPage = this.numberPdfPage - 1;
        this.numberPdfPageText = this.numberPdfPage.toString();
      });

      this.setMarkHighligth();
    } else {
      this.goFirstPage();
    }
  }

  goNextPage() {
    if (this.numberPdfPage != this.numberPdfHojasTotales && this.numberPdfPage < this.numberPdfHojasTotales) {
      this.zone.run(() => {
        this.numberPdfPage = this.numberPdfPage + 1;
        this.numberPdfPageText = this.numberPdfPage.toString();
      });

      this.setMarkHighligth();
    } else {
      this.goLastPage();
    }
  }

  private setMarkHighligth() {
    this.loadingRecord = true;
    this.showPdfNavigationButtons = false;

  }

  onResizedRecords(event: ResizedEvent): void {
    if (this.table) {
      setTimeout(() => {
        this.table.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  putPartialSelectedInDocument(event) {
    if (event.type == 'click' && event.row.parcialId != this.partialIdSelected) {
      this.partialIdSelected = event.row.parcialId;
      this.loadingRecord = true;
      this.putDocumentInViewer(event.row.imagenAsociada);
    }
  }

  setEntireDocumentInDocument() {
    if (this.partialIdSelected != undefined) {
      this.partialIdSelected = undefined;
      this.putDocumentInViewer(this.detalleExpedienteData.expediente.document.imagenAsociada);
    }
  }

  putDocumentInViewer(imagen: Imagen) {
    if (imagen) {
      if (imagen.imageSrc) {
        this.resetPdfValues(imagen.numeroHojas);

        if (this.isInDocuments) {
          this.pdfSrc = of<ArrayBuffer>(imagen.imageSrc);
          this.pdfSrcSyncronous = imagen.imageSrc;
          this.GUIDSelected = imagen.GUID;
          this.loadingRecord = false;
        }
        return;
      }

      this.imagenCacheService.getImageArrayBufferByGuid(imagen.GUID)
        .then((data: ArrayBuffer) => {
          imagen.imageSrc = data;
          this.resetPdfValues(imagen.numeroHojas);
          if (this.isInDocuments) {
            this.pdfSrc = of<ArrayBuffer>(imagen.imageSrc);
            this.pdfSrcSyncronous = imagen.imageSrc;
            this.GUIDSelected = imagen.GUID;
            this.loadingRecord = false;
          }
        });
    } else {
      this.loadingRecord = false;
    }
  }

  private resetPdfValues(numeroHojas: number) {
    this.zoomPercentage = 1;
    this.zoom = '100%';
    this.numberPdfPage = 1;
    this.numberPdfPageText = this.numberPdfPage.toString();
    this.numberPdfHojasTotales = numeroHojas;
  }

  afterLoadPdfComplete(event) {

  }

  pagePdfRendered(event) {
    if (!this.renderText) {
      this.loadingRecord = false;
    }
  }

  markHighlightsAfterRendered(event) {
    this.loadingRecord = false;

    this.zone.runOutsideAngular(() => {
      setTimeout(() => {
        const textLayer = (this.elem.nativeElement.querySelector('.textLayer') as HTMLDivElement);

        if (textLayer) {
          textLayer.innerHTML = this.highlightService.setHighlitghtsInHTML(textLayer.innerHTML, this.detalleExpedienteData.keywords.PALABRAS_CLAVE);
        }
      }, 50);
    });

  }

  clickedTabDocument() {
    this.loadingRecord = true;
    setTimeout(() => {
      this.isInDocuments = true;
      if (this.hasMainImage()) {
        this.putDocumentInViewer(this.detalleExpedienteData.expediente.document.imagenAsociada);
      } else if (this.hasPartials()) {
        this.partialIdSelected = this.detalleExpedienteData.expediente.document.parciales[0].parcialId;
        this.putDocumentInViewer(this.detalleExpedienteData.expediente.document.parciales[0].imagenAsociada);
      }
    }, 100);
  }
  private hasPartials(): boolean {
    return !!this.detalleExpedienteData.expediente.document.parciales &&
      !!this.detalleExpedienteData.expediente.document.parciales.length;
  }
  private hasMainImage(): boolean {
    return !!this.detalleExpedienteData.expediente.document.imagenAsociada;
  }

  valuePageChange(event) {
    if (this.isNumeric(event.target.value)) {
      const num = parseInt(event.target.value, 10);

      if (num >= 1 && num <= this.numberPdfHojasTotales && this.numberPdfPage != num) {
        this.numberPdfPage = num;
        return;
      }
    }
    event.target.value = this.numberPdfPage.toString();
  }

  private isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  highlightText() {
    this.renderText = !this.renderText;
    this.resetPdfValues(this.numberPdfHojasTotales);
    this.loadingRecord = true;
  }

  onPageChangePdf(event) {

    if (event == this.numberPdfPage) {
      if (this.renderText) {
        this.markHighlightsAfterRendered(event);
        return;
      }
      this.loadingRecord = false;
    }
  }

  print() {
    if (this.pdfSrcSyncronous) {
      const blob = new Blob([this.pdfSrcSyncronous], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);
      const argumentos = {
        printable: blobUrl,
        type: 'pdf',
        showModal: true,
        modalMessage: this.translateService.instant('expediente.retrievingDocument'),
        arrayBuffer: this.pdfSrcSyncronous
      };
      // printJS(argumentos);
      this.pdfService.printJS(argumentos);
    }
  }

  share() {
    if (this.pdfSrcSyncronous) {
      if (!this.linkShared) {
        this.fileService.getShareToken(this.GUIDSelected)
          .subscribe((sharedToken: string) => {
            this.linkShared = window.location.origin + '/files/' + sharedToken;
            this.openSharedLinkModal();
          });
      } else {
        this.openSharedLinkModal();
      }
    }
  }

  private openSharedLinkModal() {
    this.modalRef = this.modalService.show(this.popupShare);
  }

  copyLink() {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.linkShared;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  goToContainer(id: number) {
    this.inventoryService.goToContainers(id);
  }

  isMultivalue(value: any) {
    return value instanceof Array;
  }

  loadInventoryAZ(idAz: string) {
    this.inventoryService.goToAz(idAz);
  }

  enterChangeHistory() {
    setTimeout(() => {
      this.isInAccessChangesHistoric = true;
      this.showChangeHistory = true;
    }, 100);
  }

  leaveChangeHistory() {
    this.isInAccessChangesHistoric = false;
    this.showChangeHistory = false;
  }

  saveSecurityLevel(securityLevel) {
    this.inventoryService.changeSecurityLevel(this.detalleExpedienteData.expediente.id, securityLevel)
      .subscribe(() => {
        this.toastr.success(this.translateService.instant('expediente.levelSecurityChanged'));
      });
  }

  saveGroupsSecurityLevel(idsGroupsSecurityLevel: number[]) {
    if (!idsGroupsSecurityLevel || !idsGroupsSecurityLevel.length) {
      this.toastr.success(this.translateService.instant('expediente.groupSecurityLevelEmpty'),
        this.translateService.instant('expediente.recordGroups'));
      return;
    }
    this.inventoryService.changeGroupSecurityLevel(this.detalleExpedienteData.expediente.id, idsGroupsSecurityLevel)
      .subscribe(() => {
        this.toastr.success(this.translateService.instant('expediente.groupSecurityLevelChanged'),
          this.translateService.instant('expediente.recordGroups'));
      });
  }

  hasFile(file: ArrayBuffer) {
    return file && !!file.byteLength;
  }

  descargaDetalleExpediente() {
    this.loadingRecordGroups = true;
    this.inventoryService.descargarDetalleExpediente(this.detalleExpedienteData.expediente.id).pipe(first())
      .subscribe(data => {
        this.utilitiesService.downloadGenericFile(`${this.detalleExpedienteData.expediente.id}.pdf`, data);
        this.loadingRecordGroups = false;
      },
        error => {
          this.loadingRecordGroups = false;
          this.toastr.error(this.translateService.instant('expediente.detailDownloadError'));
        });
  }

  createLoan() {
    if (this.inventoryService.isCalledFromConsultas()) {
      this.callAddConsultaContenido(this.detalleExpedienteData.expediente, false);
    } else {
      const expediente = this.shoppingElementsService.addOrReplaceLoanElement(this.detalleExpedienteData.expediente);
      this.detalleExpedienteData.expediente = expediente as IResultadoDocument<Expedientes>;
    }
  }

  createPartialLoan() {
    if (this.inventoryService.isCalledFromConsultas()) {
      this.callAddConsultaContenido(this.detalleExpedienteData.expediente, true, this.obsPartial);
    } else {
      const containerDetails: InventoryIdenty = this.shoppingElementsService
        .addOrReplacePartialLoanElement(this.detalleExpedienteData.expediente, this.obsPartial);
      this.detalleExpedienteData.expediente.shoppingCart = containerDetails.shoppingCart;
    }
    this.closeModal();
  }

  openObsPartialModal() {
    this.isModalEdit = false;
    this.showModalText();
  }

  private showModalText() {
    const modalTitle = !this.isModalEdit ? 'inventory.tittleObsPartial' : 'inventory.tittleEditObsPartial';
    const modalTextConfirm = !this.isModalEdit ? 'inventory.createPartialLoan' : 'inventory.editPartialLoanButton';
    const modal = this.modalService.show(ModalShowTextComponent);
    (<ModalShowTextComponent>modal.content).showTextModal(
      modalTitle,
      this.obsPartial,
      modalTextConfirm
    );
    (<ModalShowTextComponent>modal.content).onClose.subscribe((result: string) => {
      if (result && result != '') {
        this.obsPartial = result;
        this.createPartialLoan();
      }
      this.closeModal();
    });
  }

  closeModal() {
    this.obsPartial = undefined;
    this.isModalEdit = false;
  }

  createInsertion() {
    const expediente = this.shoppingElementsService.addOrReplaceInsertionElement(this.detalleExpedienteData.expediente);
    this.detalleExpedienteData.expediente = expediente as IResultadoDocument<Expedientes>;
  }

  toggleSecurityLevelDataImage() {
    this.imageSecurityLevelState = this.imageSecurityLevelState == 'in' ? 'out' : 'in';
  }

  saveImageSecurityLevel(imagenId, securityLevel) {
    this.inventoryService.changeImageSecurityLevel(this.detalleExpedienteData.expediente.id, imagenId, securityLevel)
      .subscribe(() => {
        this.toastr.success(this.translateService.instant('expediente.levelSecurityChanged'));
      });
  }

  saveImagePartialSecurityLevel(imagenId, securityLevel) {
    this.inventoryService.changePartialImageSecurityLevel(this.detalleExpedienteData.expediente.id, imagenId, securityLevel)
      .subscribe(() => {
        this.toastr.success(this.translateService.instant('expediente.levelSecurityChanged'));
      });
  }

  getValueFromValuesText(textHighligth, key) {
    if (key.toLowerCase().indexOf('fecha') == -1) {
      return textHighligth;
    }

    return this.datePipe.transform(this.utcPipe.transform(textHighligth), 'dd-MM-yyyy HH:mm:ss');

  }

  refreshPageData(refreshPage: boolean) {
    if (refreshPage) {
      this.chargeDataPage();
    }

  }

}
